<template>
  <div class="promotion-previewer">
    <div style="display: flex; flex-direction: column">
      <div style="display: flex; flex: 1; position: relative">
        <img
          class="scaleToFill"
          style="width: 100%; height: 179px"
          src="https://fscdn.zto.com/fs41/M0B/F3/59/CgRReWSZUGaAfkj3AACHXYLTqn8107.png"
        />
        <div
          style="
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding-bottom: 2px;
          "
        >
          <el-carousel indicator-position="outside" height="150px" :autoplay="false">
            <el-carousel-item v-for="(item, index) in promotionData.bannerLefts" :key="index">
              <div style="padding: 10px" @click="goGoodsDetail(item)">
                <img style="height: 130px; width: 100%; border-radius: 8px" :src="item.headImage" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div style="display: flex; flex-direction: row; flex: 1; margin-top: 8px">
        <div style="width: calc(50% - 4px)">
          <div style="display: flex; flex: 1; position: relative">
            <img
              class="scaleToFill"
              style="width: 100%; height: 280px"
              src="https://fscdn.zto.com/fs41/M0B/84/5B/CgRRbWSZUGaAC1-1AAAqDeZBdgw740.png"
            />

            <div
              style="
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                padding-bottom: 2px;
              "
            >
              <div style="padding: 10px">左侧瓷片</div>
            </div>
          </div>
        </div>
        <div style="width: 8px"></div>
        <div style="width: calc(50% - 4px)">
          <div style="display: flex; flex: 1; position: relative">
            <img
              class="scaleToFill"
              style="width: 100%; height: 136px"
              src="https://fscdn.zto.com/fs41/M0B/84/5B/CgRRbWSZUGaAC1-1AAAqDeZBdgw740.png"
            />

            <div
              style="
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                padding-bottom: 2px;
              "
            >
              <div style="padding: 10px">右侧瓷片1</div>
            </div>
          </div>
          <div style="height: 8px; width: 1px" />
          <div style="display: flex; flex: 1; position: relative">
            <img
              class="scaleToFill"
              style="width: 100%; height: 136px"
              src="https://fscdn.zto.com/fs41/M0B/84/5B/CgRRbWSZUGaAC1-1AAAqDeZBdgw740.png"
            />

            <div
              style="
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                padding-bottom: 2px;
              "
            >
              <div style="padding: 10px">右侧瓷片2</div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; flex: 1; position: relative; margin-top: 8px">
        <img
          class="scaleToFill"
          style="width: 100%; height: 179px"
          src="https://fscdn.zto.com/fs41/M0B/F3/59/CgRReWSZUGaAfkj3AACHXYLTqn8107.png"
        />
        <div
          style="
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding-bottom: 2px;
          "
        >
          <el-carousel indicator-position="outside" height="150px" :autoplay="false">
            <el-carousel-item v-for="(item, index) in promotionData.bannerMiddles" :key="index">
              <div style="padding: 10px" @click="goGoodsDetail(item)">
                <img style="height: 130px; width: 100%; border-radius: 8px" :src="item.headImage" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { _, computed } from '@zto/zpage'

import PromotionItem from './promotion-item.vue'
import { ActivityPlace } from '@/config'

const props = withDefaults(
  defineProps<{
    activityData: Record<string, any>
  }>(),
  {}
)

const promotionData = computed(() => {
  const activityData = props.activityData
  const blankImage = 'https://fscdn.zto.com/fs8/M05/DE/2D/CgRfYWTV3F-AHYTgAAACDiXu3dE851.png'

  const activityItemList = props.activityData?.activityItemList || []

  let bannerLefts: any[] = [
    {
      headImage: blankImage,
      jumpAppId: '',
      jumpUrl: ''
    }
  ]

  let bannerRightTop = {
    textImage: blankImage,
    headImage: blankImage,
    jumpAppId: '',
    jumpUrl: ''
  }

  let bannerRightBottom = {
    textImage: blankImage,
    headImage: blankImage,
    jumpAppId: '',
    jumpUrl: ''
  }

  let bannerMiddles: any[] = [
    {
      headImage: blankImage,
      jumpAppId: '',
      jumpUrl: ''
    }
  ]

  if (activityData.activityPlace === ActivityPlace.BANNER_TOP) {
    bannerLefts = activityData.activityItemList || []
  } else if (activityData.activityPlace === ActivityPlace.BANNER2_LEFT) {
    bannerRightTop = { ...bannerRightTop, ...activityItemList[0] }
  } else if (activityData.activityPlace === ActivityPlace.BANNER2_RIGHT) {
    bannerRightBottom = { ...bannerRightBottom, ...activityItemList[0] }
  } else if (activityData.activityPlace === ActivityPlace.BANNER_MIDDLE) {
    bannerMiddles = activityData.activityItemList || []
  }

  return { bannerLefts, bannerRightTop, bannerRightBottom, bannerMiddles }
})

async function goGoodsDetail(item: any) {}

async function goFlashs() {}
</script>

<style lang="scss" scoped>
$primary: #ee374e;

@mixin text-lines($lines: 1) {
  overflow: hidden;
  text-overflow: ellipsis;

  @if $lines == 1 {
    white-space: nowrap;
  } @else {
    display: -webkit-box !important;
    word-break: break-all;
    -webkit-line-clamp: $lines;
    -webkit-box-orient: vertical !important;
  }
}

.promotion-previewer {
  width: 370px;
  height: 850px;

  padding: 10px;
  background: #f3f3f3;
  box-sizing: border-box;

  div {
    box-sizing: border-box;
  }
}

.promotion__body {
  display: flex;

  &__left {
    width: 160px;
  }

  &__right {
    flex: 1;
    padding-left: 8px;
  }
}

.flash-swiper {
  height: 100%;

  .swiper-item {
    &__title {
      @include text-lines(2);

      padding-top: 8px;
      font-weight: bold;
      font-size: 14px;
    }

    &__price {
      .item {
        display: inline-block;
        margin-right: 4px;
      }

      .final {
        font-size: 18px;
        color: $primary;
        line-height: 25px;
        font-weight: bold;
        padding: 5px 0;
      }

      .origin {
        font-size: 13px;
        line-height: 17px;
        color: #a1a1a1;
        text-decoration: line-through;
      }
    }
  }
}

.card-title {
  font-weight: bold;
  font-size: 15px;
}

.card-link {
  font-size: 10px;
  line-height: 15px;
}

.card-body {
  display: flex;

  .goods-item {
    margin-right: 10px;
    width: 74px;

    &:last-child {
      margin-right: 0;
    }

    &__title {
      @include text-lines();

      padding-top: 6px;
      font-size: 12px;
      line-height: 16px;
      color: #222;
    }

    &__price {
      .item {
        display: inline-block;
      }

      .final {
        font-size: 12px;
        color: $primary;
        font-weight: bold;
        line-height: 16px;
      }

      .origin {
        font-size: 10px;
        line-height: 17px;
        color: #a1a1a1;
        text-decoration: line-through;
      }
    }
  }
}
</style>
